import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getBrand } from "@faire/retailer-visitor-shared/serialized-data/getBrand";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button } from "@faire/web--source/slate/Button";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSignupSignUpModalSignInRedirectClick } from "@faire/web-api--source/events/signup/click/signUpModalSignInRedirect";
import { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/welcome/r/personal";
import React, { useCallback } from "react";
import styled from "styled-components";
export var LongSignInLink = function() {
    var linkFormatting = useCallback(function(chunks) {
        return /*#__PURE__*/ _jsx(SignInLinkButton, {
            children: chunks
        });
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "iYCkk3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Already have an account? "
                        },
                        {
                            type: 8,
                            value: "linkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Sign in"
                                }
                            ]
                        }
                    ],
                    values: {
                        linkFormatting: linkFormatting
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            })
        ]
    });
};
export var ShortSignInLink = function() {
    var isBrandPreview = getIsBrandPreview();
    var brand = getBrand();
    if (isBrandPreview) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormSpacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.critical,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "ToBL/a",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "You\u2019re already signed in as "
                            },
                            {
                                type: 1,
                                value: "brandName"
                            },
                            {
                                type: 0,
                                value: "."
                            }
                        ],
                        values: DEPRECATED_backwardsCompatibleValues({
                            brandName: brand === null || brand === void 0 ? void 0 : brand.name
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormSpacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(SignInLinkButton, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "6LiXJm",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sign in"
                        }
                    ]
                })
            })
        ]
    });
};
var FormSpacer = styled(Spacer).withConfig({
    componentId: "sc-afe415bd-0"
})([
    "",
    "{flex-basis:",
    ";min-height:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing("2x"), getSpacing("2x"));
var SignInLinkButton = function(param) {
    var children = param.children;
    var signUpParams = useQueryParams(SignUpQueryParameters.parse);
    var _signUpParams_signUp;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: getCurrentPath().delete("signUp").append({
            signIn: (_signUpParams_signUp = signUpParams.signUp) !== null && _signUpParams_signUp !== void 0 ? _signUpParams_signUp : "1"
        }).toString(),
        onClick: trackSignupSignUpModalSignInRedirectClick,
        children: children
    });
};
